import http from 'plugins/axios';

export default {
  getNoticeList(data) {
    return http.get({
      url: '/admin/notice/list',
      data
    });
  },
  createNotice(data) {
    return http.post({
      url: '/admin/notice/create',
      data
    });
  },
  updateNotice(data) {
    return http.post({
      url: '/admin/notice/update',
      data
    });
  },
  removeNotice(id) {
    return http.post({
      url: '/admin/notice/remove',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  enableNotice(id) {
    return http.post({
      url: '/admin/notice/enable',
      data: {
        id
      },
      dataType: 'form'
    });
  },
  disableNotice(id) {
    return http.post({
      url: '/admin/notice/disable',
      data: {
        id
      },
      dataType: 'form'
    });
  }
};
